import { render, staticRenderFns } from "./PhoneSetting.vue?vue&type=template&id=9408aaf0&scoped=true&"
import script from "./PhoneSetting.vue?vue&type=script&lang=js&"
export * from "./PhoneSetting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9408aaf0",
  null
  
)

export default component.exports